<template>
    <v-flex xs12 class="network-view">
        <v-flex xs12>
            <v-flex v-if="currentCommunityView === userRoles.MEMBER">
                <chapter-page></chapter-page>
            </v-flex>
            <v-flex xs12 v-else-if="currentCommunityView === userRoles.ADMIN">
                <v-flex v-if="getRequestedMembers && !hideComponents">
                    <network-joinees @onNetworkJoined="setRequestStatus"></network-joinees>
                </v-flex>
                <v-flex v-else-if="getInviteSomeOne && !hideComponents">
                    <InviteSomeone @onInviteSomeoneSuccess="setRequestStatus(NetworkConstants.SUCCESSFULLY_INVITED)" @onInviteSomeoneFail="setRequestStatus(NetworkConstants.ERROR_WHILE_INVITING)"></InviteSomeone>
                    <v-flex class="invitation-msg" v-if="requestStatus"><span>{{requestStatus}} <i class="far fa-times-circle"></i></span></v-flex>
                </v-flex>
                <v-flex v-else-if="togglePendingAssetRequests && !hideComponents">
                    <asset-pending-requests :memberId="memberId" id="AssetsSummary" />
                </v-flex>
                <v-flex v-else>
                    <chapter-page></chapter-page>
                </v-flex>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { mapGetters } from "vuex";
    import { userRoles, routerNames } from '../appCommon.constants';
    import NetworkJoinees from '../NetworkPage/NetworkJoinees';
    import InviteSomeone from '../NetworkPage/InviteSomeone';
    import { storeGetters } from '@/store/storeGetters.constant';
    import { NetworkConstants } from "../../components/NetworkPage/NetworkConstants";
    import ChapterPage from "../ChapterPage/ChapterPage.vue";
    import AssetPendingRequests from "../NetworkPage/AssetPendingRequests";
    import { trackPageLoadTime } from '../../common/utils/performance';

    export default {
        name: 'NetworkMain',
        components: {
            NetworkJoinees,
            InviteSomeone,
            ChapterPage,
            AssetPendingRequests,
        },
        mounted() {
            this.$nextTick(() => {
                trackPageLoadTime('NetworkMain');
            });
        },
        created() {
            this.$watch(() => this.$store.getters[storeGetters.communityIdPromise], () => {});
        },
        data: () => ({
            NetworkConstants,
            requestStatus: '',
            userRoles,
            routerNames,
        }),

        methods: {
            setRequestStatus(message) {
                this.requestStatus = message;
                setTimeout(() => {
                    this.requestStatus = '';
                }, 3000);
            },
        },
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                getRequestedMembers: `network/${storeGetters.getRequestedMembers}`,
                getInviteSomeOne: `network/${storeGetters.getInviteSomeOne}`,
                memberId: `memberProfile/${storeGetters.currentUserId}`,
                togglePendingAssetRequests: `network/${storeGetters.togglePendingAssetRequests}`,
            }),
            isNetworkPage() {
                return this.$route.name === routerNames.NETWORK;
            },
            hideComponents() {
                return this.$route.query && this.$route.query.postId;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .network-view {
        position: relative;

        .invitation-msg {
            position: fixed;
            top: 0;
            height: 100%;
            width: 100%;
            background: rgba($white, 0.5);
            text-align: center;
            left: 0;
            z-index: 9;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                position: relative;
                border: 1px solid rgba($ypo-gray, 0.4);
                border-radius: 4px;
                background-color: $ypo-gold;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                color: $white;
                padding: 15px 45px;
                font-size: 16px;
                font-weight: normal;
                position: relative;

                i {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    font-size: 12px;
                    cursor: pointer;
                }

                @include breakpoint(xs) {
                    bottom: inherit;
                    top: 0px;
                }
            }
        }
    }

    .forum-table {
        .headding {
            background: $ypo-dark-gray;
            color: $white;
            padding: 10px;
            text-transform: uppercase;
            font-weight: 600;
            align-items: center;
        }

        &__grid {
            &__body {
                max-height: 250px;
                overflow-y: auto;
                margin-top: 5px;
                margin-bottom: 10px;

                .layout {
                    padding: 5px 0;
                }

                span {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;
                    padding: 0 5px;
                }

                a {
                    padding: 0 10px;
                    color: $ypo_cta;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;

                    &:hover {
                        text-decoration: underline;
                    }

                }
            }

            &.full {
                a {
                    display: inline-block;
                    margin-bottom: 7px;
                }

            }
        }

        &.chapter-reports {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            .see-more {
                padding: 15px 10px;
                background-color: $ypo-extra-light-gray;
                border-top: 1px $ypo-about-border solid;
                font-size: 10px;

                a {
                    text-decoration: none;
                    color: $ypo_cta;

                    &:hover {
                        text-decoration: underline;
                    }

                }
            }
        }
    }
</style>
